import User from '@/models/user'
import getErrorStatusCode from '@/utils/error_status_code'

export default {
  namespaced: true,

  state: {
    token: window.localStorage.getItem('token'),
    user: null
  },

  actions: {
    loginWithGoogle({ commit, dispatch }, { code, redirect_uri }) {
      return User.loginWithGoogle(code, redirect_uri)
        .then(user => {
          dispatch('login', user)
          return user
        })
        .catch(err => {
          dispatch('alert/set', { code: getErrorStatusCode(err) }, { root: true })
          commit('LOGOUT')
          throw err
        })
    },

    loginWithToken({ commit, dispatch }, { token }) {
      return User.loginWithToken(token)
        .then(user => {
          dispatch('login', user)
          return user
        })
        .catch(err => {
          dispatch('alert/set', { code: getErrorStatusCode(err) }, { root: true })
          commit('LOGOUT')
          throw err
        })
    },

    revokeToken({ commit }) {
      commit('REVOKE')
    },

    invalidateToken({ commit }) {
      commit('INVALIDATE')
    },

    login({ commit, dispatch }, user) {
      commit('galleries/SET_ITEMS', user.gallery, { root: true })
      commit('LOGIN', { user })
      return Promise.resolve(user)
    },

    logout({ commit }) {
      commit('LOGOUT')
    }
  },

  mutations: {
    LOGIN(state, { user }) {
      user = new User(user)
      state.user = user
      state.token = user.token
      window.localStorage.setItem('token', user.token)
      return user
    },

    LOGOUT(state) {
      state.token = null
      state.user = null
      window.localStorage.removeItem('token')
    },

    // 模擬本機 token 遺失
    // 過期與 token 遺失會有不同的處理方式，因為沒有 token 即表示未曾登入過
    REVOKE(state) {
      state.token = null
      window.localStorage.removeItem('token')
    },

    // 模擬本機 token 過期
    // 竄改 token，刻意使 token 跟伺服器不一致而失效
    INVALIDATE(state) {
      const token = '123'
      state.token = token
      window.localStorage.setItem('token', token)
    }
  },

  getters: {
    isLoggedIn(state) {
      return !!state.user
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js